<template>
  <v-container class="pa-0">
  <h4 v-if="loading">Loading...</h4>
    <section name="header" class="header">
      <v-flex xs12 sm6>
        <h4>Topics</h4>
      </v-flex>
    </section>

    <v-data-table class="elevation-5 pa-0" :headers="headers" :items="excercises" :rows-per-page-items="rppi" :pagination.sync="pagination" item-key="id">
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
          <td>{{ props.item.topic}} - ({{props.item.targeted_exercises.length}})</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <div class="tle" v-for="(exc, idx) in props.item.targeted_exercises" :key="idx">
          <a :href=exc.downloadURL target="_blank" class="ml-1">{{exc.title}}</a>
        </div>
      </template>
    </v-data-table>

  </v-container>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      item: {},
      pagination: {},
      rppi: ["25",
        {
          text: "All",
          value: -1
        }
      ],
      headers: [
        {
          text: "Click on topic to view exercises",
          align: 'left',
          sortable: false,
          value: 'name'
        }
      ]
    }
  },
  computed: {
    excercises() {
        return this.$store.state.targeted
    },
    loading() {
      return this.$store.getters.loading
    },
  },
  methods: {
    showEx(url) {
      alert(url)
    }
  },
}
</script>

<style scoped>
.header {
  display: flex;
  align-items: baseline;
  margin-bottom: 8px;
}

h4 {
  font-size: 1.5rem;
  margin-bottom: 0px;
  margin-left: 10px;
  margin-top: 0px;
}
.name {
  font-weight: 500;
}
.text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.layout {
  margin-top: 0px;
  padding: 5px;
}
.tle {
  font-size: .95rem;
  margin-left: 30px;
  padding: 8px;
}

.txt {
  font-size: 0.95rem;
}
</style>